<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    class="modal create-geofence-from-polygon-modal"
    :class="className">
    <div
      class="modal-dialog modal-lg"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span>{{ capitalize($t('messages.geofenceCreationFromCoordinate')) }}</span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancel">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <p v-show="candidatePlaces.length > 0">
              {{ $t('messages.selectPlaceFromListOrSpecifyCustomNameAndDescription') }}
            </p>
            <ul class="items-list">
              <li
                v-for="place in candidatePlaces"
                :key="place.id">
                <label class="item">
                  <input
                    v-model="selectedPlaceCandidate"
                    type="radio"
                    name="placeCandidate"
                    :value="isNotChina ? place.name : place.title" />
                  <span>
                    <strong>{{ isNotChina ? place.name : place.title }}</strong
                    ><br />
                    <span class="small">{{ isNotChina ? place.vicinity : place.address }}</span>
                  </span>
                </label>
              </li>
              <li>
                <label class="item dd-flex flex-column">
                  <div v-show="candidatePlaces.length > 0">
                    <input
                      v-model="selectedPlaceCandidate"
                      type="radio"
                      name="placeCandidate"
                      value="custom" />
                    <strong>{{ capitalize($t('messages.custom')) }}</strong
                    ><br />
                  </div>
                  <form class="form-horizontal">
                    <div class="container-fluid">
                      <div>
                        <div class="form-group row">
                          <label class="col-sm-3 control-label">{{ capitalize($t('names.name', { n: 1 })) }}</label>
                          <input
                            v-model="newGeofenceName"
                            type="text"
                            class="form-control col-sm-8" />
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-3 control-label">{{
                            capitalize($t('names.description', { n: 1 }))
                          }}</label>
                          <textarea
                            v-model="newGeofenceDescription"
                            class="form-control col-sm-8"
                            rows="3" />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="candidatePlaces != null && candidatePlaces.length === 0"
                      class="form-group row mt-3">
                      <div class="offset-sm-3" />
                      <div class="col-sm-8">
                        <div class="alert alert-info big">
                          <span>{{ capitalize($t('messages.noPlacesWereFoundNearCoordinate')) }}</span>
                        </div>
                      </div>
                    </div>
                  </form>
                </label>
              </li>
            </ul>
            <hr />
            <div class="radius-section">
              <form
                action=""
                class="form-horizontal">
                <div class="container-fluid">
                  <div>
                    <div class="form-group row">
                      <label class="col-sm-3 control-label">{{ capitalize($t('messages.radius')) }}</label>
                      <radius-distance
                        v-if="isVisible"
                        class="col-sm-8"
                        :radius-distance="radiusDistance"
                        :use-horizontal-layout="true"
                        @radius-changed="handleRadiusChange" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            v-if="validationError"
            class="form-group row mt-3">
            <div class="offset-sm-3" />
            <div class="col-sm-8">
              <div class="alert alert-danger big">
                <span>{{ validationError }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="create_geofence_from_coordinates_btn"
            type="button"
            class="btn btn-primary"
            @click="confirm">
            <span v-if="stage !== 2">{{ $t('actions.yes') }}</span>
            <span v-if="stage === 2">{{ $t('actions.ok') }}</span>
          </button>
          <button
            v-if="stage !== 2"
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="no">
            {{ $t('actions.no') }}
          </button>
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="cancel">
            {{ $t('actions.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { DateTime } from 'luxon';
  import { capitalize } from 'vue';

  import i18n from '@/vueI18n';

  import RadiusDistance from './RadiusDistance';

  export default {
    components: {
      RadiusDistance,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      coordinate: {
        type: Object,
      },
      isNotChina: {
        type: Boolean,
        default: true,
      },
      placesNearByNewPoint: {
        type: Array,
      },
    },
    data() {
      return {
        candidatePlaces: [],
        circleRadiusDistance: 25,
        circleRadiusDistanceUnit: 'm',
        newGeofenceName: null,
        newGeofenceDescription: null,
        radiusDistance: 0.01,
        radiusUnit: 'm',
        radiusInUnit: 0.01,
        selectedPlaceCandidate: null,
        stage: 0,
        validationError: null,
      };
    },
    computed: {
      className() {
        if (this.isVisible) {
          return 'visible';
        }
        return 'fade';
      },
    },
    watch: {
      isVisible(val) {
        if (val) {
          this.resetData();
        }
      },
      coordinates() {
        this.queryPlacesAtCoordinate();
      },
    },
    mounted() {
      this.setStartingStage();
    },
    methods: {
      capitalize(x) {
        return capitalize(x);
      },
      validate() {
        switch (this.stage) {
          case 0:
            return true;
          case 1:
            if (this.selectedNearbyGeofenceID === null) {
              this.validationError = i18n.global.t('messages.pleaseSelectNearbyGeofence');
              return false;
            }
            break;
          case 2:
            if (this.newOrUpdateExistingGeofence === 'new') {
              if (this.selectedPlaceCandidate === null && this.candidatePlaces.length > 0) {
                this.validationError = i18n.global.t('messages.pleaseSelectAnExistingPlaceOrSpecifyYourOwn');
                return false;
              }
              if (
                this.selectedPlaceCandidate === 'custom' &&
                (this.newGeofenceName === null ||
                  this.newGeofenceDescription === null ||
                  this.newGeofenceName.trim() === '' ||
                  this.newGeofenceDescription.trim() === '')
              ) {
                this.validationError = i18n.global.t('messages.customGeofenceNameAndDescriptionCannotBeEmpty');
                return false;
              }
            } else if (this.selectedGeofenceID === null) {
              this.validationError = i18n.global.t('messages.pleaseSelectGeofence');
              return false;
            }
            break;
          default:
            break;
        }
        return true;
      },
      confirm() {
        if (!this.validate()) {
          return;
        }

        let customGeofenceID = null;
        let customGeofenceName = null;
        let customGeofenceDescription = null;
        let placeCandidate = null;
        if (this.selectedPlaceCandidate === 'custom' || this.candidatePlaces.length === 0) {
          customGeofenceID = DateTime.local().toSeconds();
          customGeofenceName = this.newGeofenceName;
          customGeofenceDescription = this.newGeofenceDescription;
        } else if (this.isNotChina) {
          placeCandidate = this.candidatePlaces.filter((x) => x.name === this.selectedPlaceCandidate)[0];
        } else {
          placeCandidate = this.candidatePlaces.filter((x) => x.title === this.selectedPlaceCandidate)[0];
        }
        this.$emit('confirmed', {
          placeCandidate,
          customGeofenceID,
          customGeofenceName,
          customGeofenceDescription,
          radius: this.radiusDistance,
          radiusUnit: this.radiusUnit,
          radiusInUnit: this.radiusInUnit,
        });
      },
      cancel() {
        this.$emit('cancelled');
      },
      no() {
        if (this.stage === 0) {
          if (this.nearPolygonGeofences.length > 0) {
            this.stage += 1;
          } else {
            this.stage += 2;
          }
        } else {
          this.stage += 1;
        }
      },
      setStartingStage() {
        this.stage = 2;
      },
      resetData() {
        this.setStartingStage();
        this.newOrUpdateExistingGeofence = 'new';
        this.selectedPlaceCandidate = this.stage === 2 ? 'custom' : null;
        this.selectedGeofenceID = null;
        this.selectedNearbyGeofenceID = null;
        this.newGeofenceName = null;
        this.newGeofenceDescription = null;
        this.validationError = null;

        if (this.stage === 2 && this.polygon !== null) {
          this.queryPlacesAtCoordinate();
        }
      },
      queryPlacesAtCoordinate() {
        if (window.google === undefined) {
          return;
        }
        this.candidatePlaces = [];
        // replace with Baidu
        if (this.isNotChina) {
          const service = new window.google.maps.places.PlacesService(window.document.createElement('div'));
          service.nearbySearch(
            {
              location: new window.google.maps.LatLng(this.coordinate.lat, this.coordinate.lng),
              radius: 50,
              rankby: 'distance',
            },
            (places) => {
              if (places.length > 0) {
                this.candidatePlaces = places.filter(
                  (x) => x.types.filter((y) => y.indexOf('establishment') > -1).length > 0,
                );
              }
            },
          );
        } else {
          this.candidatePlaces = this.placesNearByNewPoint;
        }
      },
      handleRadiusChange(radius, radiusUnit, radiusInUnit) {
        this.radiusDistance = radius / 1000;
        this.radiusUnit = radiusUnit;
        this.radiusInUnit = radiusInUnit;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app {
    .modal-body {
      padding: 3.2rem;

      input[type='radio'] {
        margin-right: 1rem;
      }
    }
  }

  .items-list {
    padding-left: 1.6rem;

    &.no-padding {
      padding-left: 0;
    }

    li {
      padding: 0;
      margin: 0 0 0.8rem 0;
      list-style: none;

      .item {
        margin: 0;
        display: flex;
        flex-direction: row;

        input[type='radio'] {
          margin-top: 0.4rem;
          margin-right: 0.6rem;
        }
      }
    }
  }

  .static-map {
    text-align: center;

    img {
      max-height: 320px;
    }
  }
</style>
